import { render, staticRenderFns } from "./OperateColumn.vue?vue&type=template&id=8bd8d356&scoped=true&"
import script from "./OperateColumn.vue?vue&type=script&lang=js&"
export * from "./OperateColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd8d356",
  null
  
)

export default component.exports